//
//
//
//
//
//
//
//
//
export default {
  name: 'ShiftManage',
  data: function data() {
    return {
      isRouterAlive: true
    };
  },
  created: function created() {
    console.log('created ShiftManage');
  },
  activated: function activated() {
    var _this = this;

    console.log('activated ShiftManage');
    this.isRouterAlive = false;
    this.$nextTick(function () {
      return _this.isRouterAlive = true;
    });
  }
};